export default __webpack_public_path__ + "static/media/IMG_2308.562627fd.jpg";